export const TOGGLE_NAV = 'TOGGLE_NAV';

export const toggleNav = () => ({
  type: TOGGLE_NAV
});



// WEBPACK FOOTER //
// ./src/store/nav/actions.js